"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var THEMES_URI = 'designmanager/v1/themes';

var ThemesAPI =
/*#__PURE__*/
function () {
  function ThemesAPI() {
    (0, _classCallCheck2.default)(this, ThemesAPI);
  }

  (0, _createClass2.default)(ThemesAPI, null, [{
    key: "getThemes",
    value: function getThemes() {
      return _apiClient.default.get(THEMES_URI);
    }
  }]);
  return ThemesAPI;
}();

exports.default = ThemesAPI;
module.exports = exports.default;